import React, { useEffect, useState } from 'react';
import Modal from 'components/shared/modals/Modal'
import clsx from 'clsx';
import s from './UploadModal.module.scss';

type Props = {
  isSuccess: boolean
  onClick?: () => void
  propProgress?: number
}
const uploadVideo = (progressCallback) => {
  const totalProgressSteps = 10;
  let currentStep = 0;

  const uploadInterval = setInterval(() => {
    // eslint-disable-next-line no-plusplus
    currentStep++;
    const progress = (currentStep / totalProgressSteps) * 100;
    progressCallback(progress);

    if (currentStep === totalProgressSteps) {
      clearInterval(uploadInterval);
    }
  }, 500);
};
function UploadModal({
  isSuccess,
  onClick,
  propProgress,
}: Props) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const simulateProgress = () => {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      uploadVideo((progress) => {
        setProgress(progress);
      });
    };

    simulateProgress();
  }, []);

  return (
    <Modal
      isOpen
      onClick={(e: any) => {
        e.stopPropagation();
        if (onClick) onClick();
      }}
    >
      <div className={s.container}>
        <h2 className={s.title}>Upload</h2>
        <div className={s.text}>Video upload in progress</div>
        <div className={s.progressBar}>
          <div
            className={clsx(s.innerProgressBar)}
            style={{ width: `${!isSuccess ? (propProgress || progress) : 100}%` }}
          />
        </div>
      </div>
    </Modal>
  )
}

export default UploadModal
